import { Component, ViewEncapsulation } from '@angular/core';

import { Antwoord } from '@models/claims';
import { TekstregelComponent } from '../tekstregel/tekstregel.component';
import { DataService } from '@components/public_api';

@Component({
  selector: 'app-contactgegevens',
  templateUrl: './../tekstregel/tekstregel.component.html',
  styleUrls: ['./../tekstregel/tekstregel.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ContactGegevensComponent extends TekstregelComponent {
  constructor(_dataService: DataService) {
    super(_dataService);
  }

  fillFields(): void {
    let prefilled = false;
    let validTel = false;
    let validEmail = false;
    let index = -1;

    this.vraag.antwoorden.forEach((antwoord: Antwoord) => {
      index++;
      if (antwoord.variabeleWaarde?.toUpperCase().indexOf('NAAM') > -1) {
        prefilled = true;
        antwoord.waarde = this._dataService.getStandaardwaardeTekst(antwoord);
      }
      if (antwoord.variabeleWaarde?.toUpperCase().indexOf('TELEFOON') > -1) {
        prefilled = true;
        antwoord.waarde = this._dataService.getStandaardwaardeTekst(antwoord);
        validTel = antwoord.waarde?.length > 0 && this.hasValidValue(index);
      }
      if (antwoord.variabeleWaarde?.toUpperCase().indexOf('EMAIL') > -1) {
        prefilled = true;
        antwoord.waarde = this._dataService.getStandaardwaardeTekst(antwoord);
        validEmail = antwoord.waarde?.length > 0 && this.hasValidValue(index);
      }
      if (antwoord.variabeleWaarde?.toUpperCase().indexOf('IBAN') > -1) {
        prefilled = true;
        antwoord.waarde = this._dataService.getStandaardwaardeTekst(antwoord);
      }
    });
    if (prefilled) {
      this.notifyAntwoord();
    }

    if (validTel && validEmail) {
      this.prefilledMessage = 'Kloppen onderstaande gegevens?';
    }
  }
}
